/* Copyright 2019 VMware, Inc. All rights reserved. -- VMware Confidential */
module platform {

   export class NavTreeNotificationsSubscriptionService {
      static $inject = ['$injector'];
      private _vcNavTreeNotificationsSubscriptionService: NavTreeNotificationsSubscriptionService;

      constructor(private $injector: any) {
      }

      get vcNavTreeNotificationsSubscriptionService() {
         if (!this._vcNavTreeNotificationsSubscriptionService) {
            this._vcNavTreeNotificationsSubscriptionService =
                  this.$injector.get('vcNavTreeNotificationsSubscriptionService');
         }
         return this._vcNavTreeNotificationsSubscriptionService;
      }

      openInventory(serverGuid: string): void {
         this.vcNavTreeNotificationsSubscriptionService.openInventory(serverGuid);
      }

   }
   angular.module('com.vmware.platform.ui').service('navTreeNotificationsSubscriptionService',
         NavTreeNotificationsSubscriptionService);
}